import queryString from 'query-string'
import { VitalsignAPI } from './types'

export const vitalsignApi: VitalsignAPI = ky => {
  return {
    async fetch({ patientId, before, after }) {
      return ky(`patient/${patientId}/vital_sign/`, {
        method: 'get',
        searchParams: queryString.stringify({ before, after })
      }).json()
    },

    async fetchOne({ patientId, vitalsignId }) {
      return ky(`patient/${patientId}/vital_sign/${vitalsignId}/`, {
        method: 'get'
      }).json()
    },

    async create({ patientId, payload }) {
      return await ky(`patient/${patientId}/vital_sign/`, {
        method: 'post',
        body: JSON.stringify(payload)
      }).json()
    },

    async update({ patientId, vitalsignId, payload }) {
      return await ky(`patient/${patientId}/vital_sign/${vitalsignId}/`, {
        method: 'put',
        body: JSON.stringify(payload)
      }).json()
    },

    async patch({ patientId, vitalsignId, payload }) {
      return await ky(`patient/${patientId}/vital_sign/${vitalsignId}/`, {
        method: 'patch',
        body: JSON.stringify(payload)
      }).json()
    },

    async delete({ patientId, vitalsignId }) {
      await ky(`patient/${patientId}/vital_sign/${vitalsignId}/`, {
        method: 'delete'
      })
    },

    async fetchSetting({ patientId }) {
      return ky(`patient/${patientId}/vital_sign_setting/`, {
        method: 'get'
      }).json()
    },

    async putSetting({ patientId, payload }) {
      return ky(`patient/${patientId}/vital_sign_setting/`, {
        method: 'put',
        body: JSON.stringify(payload)
      }).json()
    },

    async patchSetting({ patientId, payload }) {
      return ky(`patient/${patientId}/vital_sign_setting/`, {
        method: 'patch',
        body: JSON.stringify(payload)
      }).json()
    }
  }
}
